import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ScheduleSection } from '../components/ScheduleSection';

/**
 * Homepage: engagement photo (#22) as a full-bleed hero. The couple sits
 * center-frame, so text is anchored to the bottom over a gradient scrim rather
 * than centered (which would cover their faces).
 */
export function Home() {
  return (
    <div className="flex flex-col">
      <section className="relative flex min-h-[92vh] flex-col overflow-hidden text-cream">
        <img
          // Full-bleed hero: serve a crisp 2400px on large/retina screens and a
          // lighter 1600px on phones. sizes=100vw since it spans the viewport.
          src="/hero/engagement-22-2400.webp"
          srcSet="/hero/engagement-22-1600.webp 1600w, /hero/engagement-22-2400.webp 2400w"
          sizes="100vw"
          alt="Karishma and Ben"
          fetchPriority="high"
          decoding="async"
          className="absolute inset-0 h-full w-full object-cover object-[50%_28%]"
        />
        {/* Scrims: soften the top for the header, darken the bottom for text.
            The top band is concentrated behind the nav and fades out fast so it
            doesn't dim the sky below. */}
        <div
          aria-hidden="true"
          className="absolute inset-0"
          style={{
            background:
              'linear-gradient(to bottom, rgba(10,51,35,0.7), rgba(10,51,35,0.18) 12%, transparent 24%)',
          }}
        />
        <div
          aria-hidden="true"
          className="absolute inset-0 bg-gradient-to-t from-pine/90 via-pine/25 to-transparent"
        />

        <div className="relative z-10 flex min-h-[92vh] flex-col">
          <Header theme="dark" />

          {/* Spacer pushes the text block to the bottom, clear of their faces. */}
          <div className="flex-1" />

          <div className="mx-auto w-full max-w-6xl px-6 pb-16 text-center [text-shadow:0_2px_24px_rgba(10,51,35,0.55)]">
            <p className="mb-6 inline-flex flex-wrap items-center justify-center text-base font-medium uppercase tracking-[0.4em] text-cream sm:text-base md:text-lg">
              <span>April 30 – May 1, 2027</span>
              <span
                aria-hidden="true"
                className="ml-[0.6em] mr-[1em] inline-block h-1 w-1 rotate-45 bg-sage-moss sm:h-1.5 sm:w-1.5 md:h-2 md:w-2"
              />
              <span>Estate at River Run</span>
            </p>

            <h1 className="mb-8 font-serif text-6xl font-semibold leading-[0.95] sm:text-7xl md:text-8xl lg:text-9xl">
              Karishma <span className="italic text-blush">&amp;</span> Ben
            </h1>

            <div className="flex justify-center gap-4">
              <Link
                to="/rsvp"
                className="bg-cream px-10 py-3 text-base font-medium uppercase tracking-[0.2em] text-midnight-teal transition-colors hover:bg-dusty-rose hover:text-pine"
              >
                RSVP
              </Link>
              <Link
                to="/schedule"
                className="border border-cream/70 px-10 py-3 text-base font-medium uppercase tracking-[0.2em] text-cream transition-colors hover:bg-cream/10"
              >
                Schedule
              </Link>
            </div>
          </div>
        </div>
      </section>

      <ScheduleSection />

      <Footer />
    </div>
  );
}
